import { render, staticRenderFns } from "./ListaDeArticulos.vue?vue&type=template&id=1dfc25fe&scoped=true"
import script from "./ListaDeArticulos.vue?vue&type=script&lang=js"
export * from "./ListaDeArticulos.vue?vue&type=script&lang=js"
import style0 from "./ListaDeArticulos.vue?vue&type=style&index=0&id=1dfc25fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfc25fe",
  null
  
)

export default component.exports